/*
  Swatches on an FCS product card select a variant.

  A card stands for one set of options (a colour, say) and its swatch row holds
  the remaining option (the sizes). Hovering or clicking a swatch switches the
  whole card to that variant: photo, title, link, price and, most importantly,
  the variant the quick-add button sends to the cart.

  Bound once on the document, so cards added later by filters, infinite scroll
  or a slider work without rebinding.
*/
(function () {
  if (window.__fcsCardVariants) return;
  window.__fcsCardVariants = true;

  /* Swap the photo only once the new one is decoded, to avoid a blank frame. */
  function swapImage(img, url) {
    if (!img || !url || img.getAttribute('src') === url) return;
    var pre = new Image();
    var done = function () { img.src = url; };
    pre.onload = done;
    pre.onerror = done;
    pre.src = url;
    if (pre.complete) done();
  }

  function attr(el, name) {
    var v = el.getAttribute(name);
    return v === null ? '' : v;
  }

  function apply(card, btn) {
    if (!card || !btn) return;

    var group = btn.closest('[data-ps-variants]');
    if (group) {
      group.querySelectorAll('[data-ps-variant-btn]').forEach(function (b) {
        b.classList.remove('is-active');
      });
    }
    btn.classList.add('is-active');

    swapImage(card.querySelector('[data-ps-main-img]'), attr(btn, 'data-variant-img'));

    var url = attr(btn, 'data-variant-url');
    var title = card.querySelector('.fcs-card__title');
    if (title) {
      var t = attr(btn, 'data-variant-card-title');
      if (t) title.textContent = t;
      if (url) title.setAttribute('href', url);
    }
    var imageLink = card.querySelector('.fcs-card__image-wrap a');
    if (imageLink && url) imageLink.setAttribute('href', url);

    var price = card.querySelector('.fcs-price');
    var priceText = attr(btn, 'data-variant-price');
    if (price && priceText) price.textContent = priceText;

    var compare = card.querySelector('.fcs-price-compare');
    if (compare) {
      var onSale = attr(btn, 'data-variant-on-sale') === '1';
      var compareText = attr(btn, 'data-variant-compare');
      compare.textContent = onSale ? compareText : '';
      compare.hidden = !onSale;
    }

    /* The quick-add form posts this id, so the shopper gets the size they picked. */
    var id = attr(btn, 'data-variant-id');
    var input = card.querySelector('form input[name="id"]');
    if (input && id) input.value = id;

    var addButton = card.querySelector('[data-add-to-cart]');
    if (addButton && btn.hasAttribute('data-variant-available')) {
      var available = attr(btn, 'data-variant-available') !== '0';
      addButton.disabled = !available;
      addButton.classList.toggle('is-unavailable', !available);
    }
  }

  function handler(e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-ps-variant-btn]');
    if (!btn) return null;
    return btn;
  }

  document.addEventListener('mouseover', function (e) {
    var btn = handler(e);
    if (btn) apply(btn.closest('.fcs-card'), btn);
  });

  document.addEventListener('click', function (e) {
    var btn = handler(e);
    if (!btn) return;
    /* Leave modified clicks alone so opening in a new tab still works. */
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    apply(btn.closest('.fcs-card'), btn);
  });
})();
